import { render, staticRenderFns } from "./accountJournalInitList.vue?vue&type=template&id=24804af2"
import script from "./accountJournalInitList.vue?vue&type=script&lang=js"
export * from "./accountJournalInitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports